import { Box, Typography } from "@mui/material";
import { ORCID_ICON } from "@/src/constant/constant";
import Image from "next/image";
import React from "react";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import Link from "next/link";
import Kicker from "@/src/components/common/broadsheet/kicker";

const ArticleAuthors = ({ authors }: { authors: Author[] }) => (
  <>
    <Kicker component="p" sx={{ mb: 0.25 }}>
      Authors
    </Kicker>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.25
      }}>
      {authors.map(
        (author: Author, index: number) =>
          (author.first_name !== "" ||
            author.middle_name !== "" ||
            author.last_name !== "") && (
            <Box
              component="bdi"
              key={`document-author-${index}`}
              sx={{
                display: "flex",
                alignItems: "center",
                color: "text.primary"
              }}>
              <SpanTypography sx={{
                fontSize: ".875rem"
              }}>
                <SpanTypography
                  sx={{
                    fontSize: ".875rem",
                    mr: 0.25
                  }}>
                  {`${author.first_name}${
                    author.middle_name ? ` ${author.middle_name} ` : ""
                  } ${author.last_name ?? ""}`}
                </SpanTypography>
                {author.orcid && (
                  <Link
                    href={`https://orcid.org/${author.orcid}`}
                    style={{ marginRight: 2 }}
                  >
                    <Image
                      src={ORCID_ICON}
                      width={15}
                      height={15}
                      style={{ verticalAlign: "middle" }}
                      title={"ORCID"}
                      alt={`${author.first_name}${
                        author.middle_name ? ` ${author.middle_name}` : ""
                      } ${author.last_name} ORCID`}
                    />
                  </Link>
                )}
                <Typography component={"sup"}>
                  {author.equal_contrib === "yes" && "#"}
                  {author.deceased !== "" && author.deceased}
                  {Object.entries(author.affiliations).map(
                    ([id, label], index, array) => (
                      <React.Fragment key={id}>
                        <Box
                          component={Link}
                          href={`#${id}`}
                          sx={{
                            fontSize: ".8rem",
                            color: "custom.link",
                            textDecoration: "none",
                          }}
                        >
                          {label as string}
                        </Box>
                        {index < array.length - 1 && ", "}
                      </React.Fragment>
                    ),
                  )}
                  {author.correspond &&
                    author.correspondence_id !== "" &&
                    author.correspondence_id !== "" && (
                      <>
                        <SpanTypography sx={{
                          fontSize: 10
                        }}>,</SpanTypography>
                        <Box
                          component={Link}
                          href={`#${author.correspondence_id}`}
                          sx={{
                            fontSize: ".7rem",
                            color: "custom.link",
                            textDecoration: "none",
                          }}
                        >
                          {author.correspondence_label}
                        </Box>
                      </>
                    )}
                </Typography>
              </SpanTypography>
              {index !== authors.length - 1 && ", "}
            </Box>
          ),
      )}
    </Box>
  </>
);

export default ArticleAuthors;
